import { NetworkHeadlineComponent } from '@app/feature/dashboard/network-state-headline/network-state-headline.component';

import * as css from './dashboard.module.scss';
import { MaintenanceCardComponent } from './maintenance/maintenance-card.component';
import { NetworkCardComponent } from './network/network-card.component';
import { StatisticsComponent } from './statistics/statistics.component';

export const DashboardView = (): React.JSX.Element => {
  return (
    <>
      <NetworkHeadlineComponent />
      <div className={css.container}>
        <NetworkCardComponent />
        <MaintenanceCardComponent />
      </div>
      <StatisticsComponent />
    </>
  );
};
